var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.data.style.innerListStyle)?_c('div',{staticClass:"minisite-list",style:(_vm.getListStyle)},[_c('template-00',{attrs:{"data":_vm.data}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }